/**
 * Test component for viewing the Approval Document Modal
 *
 * Usage: Import and render this component anywhere to test the document
 *
 * Example:
 *   import { ApprovalDocumentTest } from './approval-document/ApprovalDocumentTest';
 *   <ApprovalDocumentTest />
 *
 * DELETE THIS FILE after testing
 */

import React, { useState } from 'react';
import { ApprovalDocumentModal } from './ApprovalDocumentModal';
import { createSampleApprovalDocument } from './approvalDocument.utils';

export const ApprovalDocumentTest: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const sampleData = createSampleApprovalDocument();

  return (
    <div style={{ padding: '20px' }}>
      <h3>Approval Document Test</h3>
      <button
        onClick={() => setIsOpen(true)}
        style={{
          padding: '12px 24px',
          backgroundColor: '#1e40af',
          color: 'white',
          border: 'none',
          borderRadius: '8px',
          fontSize: '16px',
          fontWeight: 600,
          cursor: 'pointer',
        }}
      >
        Open Approval Document Preview
      </button>

      <ApprovalDocumentModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        data={sampleData}
      />
    </div>
  );
};

export default ApprovalDocumentTest;
